module.exports = __webpack_public_path__ + "static/media/close.fa5a1660.png";